var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingPhone1 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85786 0.528162L2.53036 0.313162C3.16161 0.111912 3.83473 0.437537 4.10536 1.07379L4.64223 2.34129C4.87598 2.89316 4.74661 3.54254 4.32098 3.94629L3.13723 5.07004C3.20973 5.74254 3.43598 6.40441 3.81473 7.05566C4.1746 7.6858 4.65725 8.23731 5.23411 8.67754L6.65598 8.20254C7.19536 8.02316 7.78223 8.23004 8.11223 8.71566L8.88286 9.84691C9.26723 10.4119 9.19848 11.1907 8.72161 11.6694L8.21036 12.1825C7.70161 12.6932 6.97473 12.8788 6.30286 12.6688C4.71598 12.1738 3.25723 10.7044 1.92598 8.26066C0.592857 5.81316 0.122232 3.73566 0.514732 2.03066C0.679732 1.31316 1.19036 0.741287 1.85786 0.528162Z",
    fill: "#7E8899"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingPhone1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settingPhone1.ac23a97c83941ee97410fca8239a481f.svg";